export const filterDays = 90;

export const WEBPAGE_LEADS_LEARN_MORE_HREFS = {
  WEBPAGE_LEADS:
    "https://support.exlyapp.com/support/solutions/articles/84000347724-webpage-leads-tool-on-exly",
  WEBPAGE_LEADS_VIDEO: "https://www.youtube-nocookie.com/embed/rw5_74I1PKg",
};
